module.exports = __webpack_public_path__ + "static/media/how_zh_tw.c52d05a0.vtt";